.bz{overflow:hidden;}